const MILLISECONDS_PER_DAY = 86400000;

const getDifferenceInDays = (formattedDate: string) => {
  const dateNow = new Date();
  const expirationDate = new Date(formattedDate);
  const timeDifferenceInMilliseconds = expirationDate.getTime() - dateNow.getTime();
  const differenceInDays = timeDifferenceInMilliseconds / MILLISECONDS_PER_DAY;
  return differenceInDays;
};

export default getDifferenceInDays;
